import { render, staticRenderFns } from "./personalCustomMenuList.vue?vue&type=template&id=5b61e8a2&scoped=true"
import script from "./personalCustomMenuList.vue?vue&type=script&lang=js"
export * from "./personalCustomMenuList.vue?vue&type=script&lang=js"
import style0 from "./personalCustomMenuList.vue?vue&type=style&index=0&id=5b61e8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61e8a2",
  null
  
)

export default component.exports